//
// URL processing helpers
//

// Gets query params from url
export function getQueryParams(uri) {
  uri = uri || window.location.search;
  const qs = uri.split('+').join(' ');

  const params = {};
  const re = /[?&]?([^=]+)=([^&]*)/g;
  let tokens;

  while (tokens = re.exec(qs)) {
    let key = decodeURIComponent(tokens[1]);
    let val = decodeURIComponent(tokens[2]);
    
    try {
      val = JSON.parse(val);
    } catch(e) {}

    params[key] = val;
  }

  return params;
}


// Pass this as value to setQueryParams if you want to just delete it from url
export const REMOVE_URL_PARAM = 'setQueryParams-remove';

/**
 * Add / Update a key-value pair in the URL query parameters
 * @param {*} key 
 * @param {*} value 
 * @param {*} options
 */
export function setQueryParams(key, value, options = {}) {
  options = Object.assign(options, { 
    retainHash: true, 
    clearOthers: false, 
    setLocation: true 
  });

  const params = options.clearOthers ? {} : getQueryParams();

  // Deleting completely?
  if (value === REMOVE_URL_PARAM) {
    delete params[key];
  } else {
    // Addition
    try {
      params[key] = typeof value === 'object' ? JSON.stringify(value) : value;
    } catch(e) {
      return;
    }
  }

  let uri = window.location.origin + window.location.pathname + '?';
  uri = uri + Object.keys(params)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');

  if (options.retainHash) {
    uri = uri + window.location.hash;
  }

  if (options.setLocation) {
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, '', uri);
    } else {
      window.location = uri;
    }
  }

  return uri;
}